<template>
  <v-container class="fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="8" align="center" justify="center">
        <v-row justify="center" class="mt-8 mb-10">
          <p class="mb-0">お申込みが完了しました。</p>
          <p class="mb-0">後ほどお申込み受付完了メール（自動送信）をお送りいたします。</p>
          <p class="mb-0">数日経ってもメールが届かない場合、お問い合わせをお願いいたします。</p>
        </v-row>
        <a color="secondary" href="https://www.edu-network.jp/shop/pages/dg-getthrough2600.aspx">
          TOPへ
        </a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  components: {
  },
  props: {
    source: String,
  },
  mounted() {
    this.$store.commit('enrollment/initialize', {})
  },
}
</script>

<style lang="stylus">
.v-input__slot
  min-height 40px !important
  margin-bottom 4px !important
.v-text-field__details
  background-color white !important
  margin-bottom 8px !important
  padding 0px 12px !important
</style>

<style lang="stylus" scoped>
.logo-area
  position relative
  margin-bottom 90px

.logo
  position absolute
  left 24%

.background
  background-image: linear-gradient(to bottom, #335e8d, #4a8cae 30%, #2b638d);

.signin-btn
  color: white !important;
  margin-top: 60px;
  background-image: linear-gradient(to bottom, #10318b, #55669b 30%, #2b3555);
  // background-image: linear-gradient(to bottom, #ffffff, #e7e7e7, #ffffff);

</style>
